import type {
	ChangeEventHandler,
	FocusEventHandler,
	KeyboardEventHandler,
	ReactNode
} from 'react'

import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import makeStyles from '@mui/styles/makeStyles'
import { useId } from 'react'

function TextFieldCustom({
	endAdornment,
	label,
	onBlur,
	onChange,
	onEnter,
	placeholder,
	value
}: {
	endAdornment?: ReactNode
	label?: string
	onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
	onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
	onEnter?: KeyboardEventHandler<HTMLDivElement>
	placeholder?: string
	value?: string
}) {
	const classes = useStyles()
	const uniqueId = useId()

	const onKeyUp: KeyboardEventHandler<HTMLDivElement> = e => {
		if (e.key === 'Enter') {
			onEnter?.(e)
		}
	}

	const endIcon = endAdornment ? (
		<InputAdornment position='end'>{endAdornment}</InputAdornment>
	) : (
		''
	)

	return (
		<div className='text-field'>
			{label && (
				<label className='select-label text-field__label' htmlFor={uniqueId}>
					{label}
				</label>
			)}
			<TextField
				classes={classes}
				id={uniqueId}
				margin='none'
				onBlur={onBlur}
				onChange={onChange}
				onKeyUp={onKeyUp}
				placeholder={placeholder}
				slotProps={{
					input: {
						endAdornment: endIcon
					}
				}}
				type='text'
				value={value}
				variant='outlined'
			/>
		</div>
	)
}

const useStyles = makeStyles(_ => ({
	root: {
		'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#0cb39f',
			borderWidth: '1px'
		},
		'& .MuiOutlinedInput-input': {
			backgroundColor: '#ffffff',
			color: '#202020',
			fontSize: '14px',
			fontWeight: 'normal',
			lineHeight: '20px',
			padding: '8px 40px 8px 13px'
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#0cb39f',
			borderWidth: '1px'
		},
		backgroundColor: '#fff',
		width: '220px'
	}
}))

export default TextFieldCustom
